import Vue from "vue";
import moment from "moment";
export default Vue.extend({
    data() {
        return {
            date: moment().format("YYYY-MM-DD"),
            menu: false,
            loading: false,
            hint: "",
        };
    },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        close: {
            type: Function,
            default: () => { },
        },
        invoice: {
            type: Object,
            default: {},
        },
    },
    computed: {
        invoiceRestructured() {
            if (!this.invoice)
                return [];
            return [
                { header: "Contact", value: this.invoice.customerContactPerson },
                {
                    header: "Description",
                    value: this.invoice.description,
                },
                { header: "Total", value: `${this.invoice.totalAmount} kr` },
                {
                    header: "Total incl. VAT",
                    value: `${this.invoice.totalAmountInclVAT} kr`,
                },
            ];
        },
    },
    methods: {
        closeDialog() {
            this.$emit("close");
        },
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        async createInvoice(invoice, date) {
            if (!invoice || !date)
                return console.error(`${invoice ? "Invoice" : "Date"} not defined in createInvoice()`);
            this.loading = true;
            const response = await this.$store.dispatch("createInvoice", {
                year: moment(date).format("YYYY"),
                month: moment(date).format("MM"),
                salesOrderId: invoice.id,
                invoiceDate: moment.utc(date).format(),
            });
            if (response && response.status === 204) {
                this.hint = "Invoice has been sucessfully created!";
            }
            else {
                this.hint = "Invoice could not be created!";
            }
            this.loading = false;
        },
    },
    watch: {
        date() {
            this.hint = "";
        },
    },
});
